//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import 'devextreme/ui/popup'
import 'devextreme/ui/toolbar'
import 'devextreme/ui/load_indicator'

//#endregion

import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { Enums } from '../../../models/common/enums'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { IMRBaseControlController } from '../base'
import { IIMRServiceman, IMRServicemanOptions } from './serviceman.interfaces'
import { UserSessionService } from '../../../services/user-session'
import { OpOperator } from '../../../models/core'
import { IIMRPopup, IMRPopupOptions } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'
import { TypeHelper } from '../../../helpers'
import { ColumnModel } from 'app/modules/api/api.models'

export class IMRServicemanController extends
    IMRBaseControlController<IIMRServiceman, IMRServicemanOptions>
    implements
    IIMRServiceman {

    //#region members
    public popupOptions: IMRPopupOptions
    public toolbarOptions: DevExpress.ui.dxToolbarOptions
    public data: any
    public gridOptions: GridOptions
    public columnsCount: number

    // public servicemansLoaded: boolean

    private popup: IIMRPopup
    private grid: DevExpress.ui.dxDataGrid
    private selectedIds: any[]
    private allServicemans: OpOperator[]

    //#endregion

    //#region Ctor

    constructor(
        private userSessionService: UserSessionService
    ) {
        super()
    }

    //#endregion

    //#region Component

    protected initialize(options: IMRServicemanOptions): JQueryPromise<void> {
        const defer: JQueryDeferred<void> = $.Deferred<void>()

        $.when(this.initializePopup())
            .then(() => {
                defer.resolve()
            })

        return defer.promise()
    }

    //#endregion

    //#region IIMRDepositoryParameters implementation

    public show(): void {
        if (this.popup != null) {
            this.selectedIds = <any[]>OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ServicemansSelection)

            this.popup.show()

            this.getAllServicemans()
                .then((operators: OpOperator[]) => {
                    this.allServicemans = operators
                    this.drawGrid()
                })
        }
    }

    public hide(): void {
        if (this.popup != null) {
            this.popup.hide()
        }
    }

    //#endregion    


    //#region content

    private initializePopup(): JQueryPromise<void> {
        this.popupOptions = {
            bottomToolbarOptions: {
                innerOptions: {
                    items: this.getToolbarItems(),
                }
            },

            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectServicemans),
                maxWidth: '500px'
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.popup = e.component
            },
            onHiding: () => {
                this.gridOptions = null
            }
        }

        return TypeHelper.onInitializedAll(this.popupOptions)
    }

    private getToolbarItems(): DevExpress.ui.dxToolbarItem[] {
        return [{
            location: 'after',
            widget: 'dxButton',
            options: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
                onClick: () => {
                    this.onSubmitClicked()
                }
            }
        }]
    }

    //#endregion

    private submitSevicemans(selected: any[]): void {
        const ids: any[] = []
        for (let i in selected) {
            ids.push({ id: selected[i].id })
        }
        this.hide()
        this.selectedIds = ids
        OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ServicemansSelection, this.selectedIds)

        if (_.isFunction(this.options.onServicemanRefreshed)) {
            this.options.onServicemanRefreshed(ids)
        }
    }

    private onSubmitClicked(): void {
        let selectedServicemen: any = this.grid.getSelectedRowsData()

        if (this.submitSevicemans) {
            if (selectedServicemen.length) {
                this.submitSevicemans(selectedServicemen)
            } else {
                selectedServicemen.then(selected => {
                    this.submitSevicemans(selected)
                })
            }
        } else {
            this.submitSevicemans([])
        }
    }

    private getAllServicemans(): JQueryPromise<OpOperator[]> {
        this.popup.showLoading()

        return this.userSessionService
            .getDataProvider()
            .Operator
            .getFitterOperators()
            .then((result: OpOperator[]) => {
                const operators: OpOperator[] = _.filter(result, (item: OpOperator) => item.area != null)

                return operators
            })
            .always(() => {
                this.popup.hideLoading()
            })
    }

    private drawGrid(): void {
        const columns: ColumnModel[] = [<ColumnModel>{ id: 1, idName: "name", name: 'Name', caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name) }]
        let isFirstLoad = true;

        this.gridOptions = {
            type: GridTypes.MAIN,
            idReferenceType: Enums.ReferenceType.IdOperator,
            name: "ServicemansSel",
            selection: {
                mode: 'multiple',
                showCheckBoxesMode: 'always',
                selectAllMode: 'allPages',
                deferred: true
            },
            dataSource: this.getGridDataSource(),

            buttonsOptions: {
                enabled: true,
            },
            columnsDictionary: columns,
            columnAutoWidth: true,
            onContentReady: () => {
                if (isFirstLoad) {
                    this.selectServicemenRows()
                }

                isFirstLoad = false;
            },
            onInitialized: (e) => {
                this.grid = e.component
            },
            addCustomFilters: true
        }
    }

    private getGridDataSource(): DataSource {
        return new DataSource(_.map(this.allServicemans, (op: OpOperator) => {
            return {
                id: op.idOperator,
                name: op.toString()
            }
        }))
    }

    private selectServicemenRows() {
        if (_.size(this.selectedIds) > 0 && _.size(this.allServicemans) > 0) {
            const toSelect: number[] = this.allServicemans.filter((s: OpOperator) => this.selectedIds.map(m => m.id).indexOf(s.idOperator) > -1).map((x: OpOperator) => x.idOperator)

            this.grid.selectRows(toSelect, false)
        }
        else {
            this.grid.selectRows([], false);
        }
    }
}